// Imports
console.log('running');
import {
    stickerConfigurations,
    productConfigurations
} from './config.js';


import {
    setupEventListeners,attachItemListeners
   
} from './eventListeners.js';



import {
    initializeDraw,destroyDraw,
    updateSVGSizeType,
    setupDefaultImage,
    createItemOnCanvas,
    setupItemsOnCanvas,
    appendStickerToCanvas,
    
    showcaseEditableSVGElements,
    updatePageTemplate
} from './drawFunctions.js';

import { HfInference } from '@huggingface/inference';
import { HfAgent, LLMFromHub } from '@huggingface/agents';


// Constants and Global Variables
const CAROUSEL_WIDTH = 300;
const carouselItems = document.querySelectorAll('.carousel-item');


let textPlaceholder, namePlaceholder;
 window.currentPage = 'front_cover';
let currentSlide = 0;



// Initial setting
let SKU = document.getElementById('cardType').value;
let shopifyProductCode = document.getElementById('shopifyProductCode').value;
   
if (shopifyProductCode) {
    setSKU(shopifyProductCode);
}else{
setSKU('a4_acrylic_landscape');
}
// Setter function
export function setSKU(newSKU) {
    SKU = newSKU;
}

// Getter function
export function getSKU() {
    return SKU;
}

// Export SKU
export { SKU };



let handler = {
    set: function (target, key, value) {
        // Whenever a property in cardState changes, this code will execute
        updateStatusIndicator('updating');
        target[key] = value;
        setTimeout(() => {
            updateStatusIndicator('idle');
        }, 500); // Adjust this delay based on your needs
        return true;
    }
};



function initializeApp() {

   const savedState = localStorage.getItem('cardState');
    if (savedState) {
        cardState = JSON.parse(savedState);
      console.log('saved');
       console.log(cardState);
   }
   
    Object.keys(productConfigurations[SKU]).reverse().forEach(updatePageTemplate);
 
   

}

// Initialization
document.addEventListener("DOMContentLoaded", function() {


        // Your initialization logic here...
        initializeDraw();
        initializeApp();
        setupEventListeners();

        // Initialize state for each page in the product configurations
        Object.keys(productConfigurations).forEach(pageSKU => {
            Object.keys(productConfigurations[SKU]).forEach(page => {
                initializeSavedState(SKU, page);
            });
        });

     
    
});


function updateCardStateWithItemProperties(item, type) {
    const id = item.node.getAttribute('data-item-id'); // Use the new attribute
    const itemsArray = type === 'sticker' ? cardState[SKU][currentPage].stickers : cardState[SKU][currentPage].user_photo;

    const itemIndex = itemsArray.findIndex(i => i.id === id);
    if (itemIndex !== -1) {
        const updatedItem = {
            ...itemsArray[itemIndex],
            x: item.x(),
            y: item.y(),
            width: item.width(),
            height: item.height()
        };
        itemsArray[itemIndex] = updatedItem;
    }
    localStorage.setItem('cardState', JSON.stringify(cardState));
}


function updateStatusIndicator(status) {
    const statusIndicator = document.getElementById('statusIndicator');
    if (statusIndicator) {
        statusIndicator.textContent = status;
    }
}
document.getElementById('showCardStateBtn').addEventListener('click', function () {
    const display = document.getElementById('cardStateDisplay');
    if (display.style.display === 'none') {
        display.textContent = JSON.stringify(cardState, null, 2); // The '2' parameter here is for pretty-printing the JSON
        display.style.display = 'block';
    } else {
        display.style.display = 'none';s
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const cardContainers = document.querySelectorAll('.card-container');

    cardContainers.forEach((container) => {
        container.addEventListener("click", function(event) {
            const sku = event.currentTarget.getAttribute('data-sku');
            if (sku) {
                setSKU(sku);
                updateCardForSelectedType(sku);
                
                // Smooth scroll to the top of the page
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        });
    });
});

function updateCardForSelectedType(product_data) {
   
    destroyDraw();initializeDraw();
    const pagesToUpdate = productConfigurations[product_data];
    Object.keys(pagesToUpdate).forEach(updatePageTemplate);
}

    // Event listener for radio buttons
    document.querySelectorAll('input[name="productType"]').forEach(radio => {
        radio.addEventListener('change', function() {
            updateProductSelectorCarosel(this.value);
        });
    });

// Function to update the product selector carousel based on the selected product type
function updateProductSelectorCarosel(productType) {

    const carousel = document.getElementById('cardCarousel');
    carousel.innerHTML = '';  // Clear existing items

    for (const key in productConfigurations) {
        for (const subKey in productConfigurations[key]) {
            if (productConfigurations[key][subKey].type === productType) {
                const carouselItem = document.createElement('div');
                carouselItem.className = 'carousel-item';
                carouselItem.dataset.page = key;
                
                const itemText = document.createElement('span');
                itemText.textContent = key.charAt(0).toUpperCase() + key.slice(1) + ' ' + subKey.charAt(0).toUpperCase() + subKey.slice(1);

                carouselItem.appendChild(itemText);
                carousel.appendChild(carouselItem);
                break;  // Exit the loop once a matching type is found for this product
            }
        }
    }

    // Add click event listeners to the carousel items
     // Add click event listeners to the carousel items
     const carouselItems = document.querySelectorAll('.carousel-item');
     console.log("Number of carousel items found:", carouselItems.length);  // Debugging line
 
     carouselItems.forEach(item => {
        console.log("Adding click event listener to a carousel item");  // Debugging line
        item.addEventListener('click', function(event) {
            console.log("Inside event listener");  // Debugging line
            const targetElement = event.currentTarget;
            const pageType = targetElement.getAttribute('data-page');
            setSKU(pageType);
            console.log("Carousel item clicked, pageType:", pageType);  // Debugging line
    
            if (pageType) {
                document.getElementById('cardType').value = pageType;
                destroyDraw();
                initializeDraw();
                initializeApp();
            }
        });
    });  
  }


export function createCarouselTray() {
    const tray = document.createElement('div');
    tray.id = 'carousel-tray';
    document.body.appendChild(tray);
    return tray;
}

function openTray() {
    const stickerDiv = document.querySelector('.editor-container');
    stickerDiv.classList.add('open');
    stickerDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
    });
}














// Initialize global variables
export let cardState = {};  // Initialize with your actual initial state if needed
export let undoStacks = {};
export let redoStacks = {};
export let uniqueId = "";  // This needs to be set appropriately, e.g., user session ID or user account ID


export let initialState = {
    cardState: {},
    undoStacks: {},
    redoStacks: {},
    uniqueId: "",
    currentPage: ""
  };


// Initialize with the saved state if available
function initializeSavedState(SKU, currentPage) {
    const savedState = localStorage.getItem(`cardState`);
    if (savedState) {
        cardState[SKU] = cardState[SKU] || {};
        cardState[SKU][currentPage] = JSON.parse(savedState);
    } else {
        cardState[SKU] = cardState[SKU] || {};
        cardState[SKU][currentPage] = cardState[SKU][currentPage] || {};
    }
}
/**
 * Universal function to handle SVG Actions.
 *
 * @param {string} actionType - The type of action being performed (e.g., 'UPDATE_PROPERTY').
 * @param {Object} actionData - The data associated with the action.
 * @param {string} SKU - The SKU identifying the product.
 * @param {string} currentPage - The current page being edited.
 */
export function handleSVGActions(actionType, actionData, SKU, currentPage) {
console.log('svg action');
    console.log(actionType);
console.log(actionData);
console.log(SKU);
console.log(currentPage);
   // Initialize if they don't exist
  // Initialize state for SKU and currentPage if not present
  initialState.cardState[SKU] = initialState.cardState[SKU] || {};
  initialState.cardState[SKU][currentPage] = initialState.cardState[SKU][currentPage] || {};

   // Save the previous state
   const previousState = JSON.parse(JSON.stringify(initialState.cardState[SKU][currentPage]));
   initialState.undoStacks[currentPage] = initialState.undoStacks[currentPage] || [];
   initialState.undoStacks[currentPage].push(previousState);
 
   // Clear the redoStack for the currentPage ONLY when a new action is made
   initialState.redoStacks[currentPage] = [];
 
   // Perform the action
   switch(actionType) {
     case 'UPDATE_PROPERTY':
       for (const [key, value] of Object.entries(actionData)) {
         initialState.cardState[SKU][currentPage][key] = value;
       }
       break;
     // Add more cases for other types of actions, like 'ADD_TEXT', 'REMOVE_PHOTO', etc.
   }
  }
  

export function undo(SKU, currentPage) {
    console.log(initialState);
    if (initialState.undoStacks[currentPage] && initialState.undoStacks[currentPage].length > 0) {
      const lastState = initialState.undoStacks[currentPage].pop();
      initialState.redoStacks[currentPage] = initialState.redoStacks[currentPage] || [];
      initialState.redoStacks[currentPage].push(JSON.parse(JSON.stringify(initialState.cardState[SKU][currentPage])));
      
      initialState.cardState[SKU][currentPage] = lastState;
    } console.log(initialState);
  }
  
  export function redo(SKU, currentPage) {
    if (initialState.redoStacks[currentPage] && initialState.redoStacks[currentPage].length > 0) {
      const nextState = initialState.redoStacks[currentPage].pop();
      initialState.undoStacks[currentPage].push(JSON.parse(JSON.stringify(initialState.cardState[SKU][currentPage])));
      
      initialState.cardState[SKU][currentPage] = nextState;
    }
  }
  
  document.addEventListener('update', function(e) {
    e.preventDefault();  
    e.stopPropagation();
    console.log('update event');
    // Retrieve the shopifyProductCode within the update event
    let shopifyProductCode = document.getElementById('shopifyProductCode').value;
    console.log("Shopify Product Code:", shopifyProductCode);
    if (shopifyProductCode) {
        setSKU(shopifyProductCode);
        //destroyDraw();//disable, all original pages will remain
        //initializeDraw();
        Object.keys(productConfigurations[SKU]).reverse().forEach(updatePageTemplate);
    }
});
// Initialize with the saved state if available

